import { render, staticRenderFns } from "./MdNewsCenter2.vue?vue&type=template&id=aea10c56&scoped=true&"
import script from "./MdNewsCenter2.vue?vue&type=script&lang=js&"
export * from "./MdNewsCenter2.vue?vue&type=script&lang=js&"
import style0 from "./MdNewsCenter2.vue?vue&type=style&index=0&id=aea10c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea10c56",
  null
  
)

export default component.exports